module.exports = __webpack_public_path__ + "img/saas_2.be4acbf6.png";